import React from 'react';
import { Map } from 'immutable';
import { of } from 'rxjs';
import { Brand, Links } from '../../brand';
var brand = new Brand({
  id: 'nwi',
  brandLogo: 'natwesti',
  name: 'NatWest International',
  copyright: "\xA9 2005-".concat(new Date().getFullYear(), " The Royal Bank of Scotland International Limited"),
  footer: Map({
    'Legal Info': 'https://www.natwestinternational.com/terms_conditions',
    Security: 'https://www.natwestinternational.com/security',
    'Privacy & Cookies': 'https://www.natwestinternational.com/cookiesprivacy',
    Accessibility: 'https://www.natwestinternational.com/accessibility'
  }),
  links: new Links({
    Home: 'https://www.natwestinternational.com',
    availableBalanceMeaning: 'https://supportcentre.natwestinternational.com/1013838862',
    support: 'https://www.natwestinternational.com/personal/help-support/support-centre.html',
    reportFraud: 'https://www.natwestinternational.com/olb_reportingfraud',
    contactLink: 'https://www.natwestinternational.com/personal/help-support/support-centre/contact-us.html'
  }),
  home: 'Online Banking',
  helpNowBrand: 'natwestoffshore',
  ssoEnabled: false,
  copy: Map({
    'changes-90-day-auth-access.details': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "zb-no-margin"
    }, "From the ", /*#__PURE__*/React.createElement("b", null, "22nd August 2022"), ", the rules for access to account information are changing. This means that in future you won't need to regularly re-authenticate with us except in certain circumstances when we may need additional reassurance to check that it is you. ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), " You will instead need to reconfirm your consent with your service provider every 90 days.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), " You can stop sharing at any time by disconnecting an agreement.")),
    'changes-90-day-auth-access.title': 'Changes to 90-day access to account information'
  })
});
export var brand$ = of(brand);